import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'peakTime'
})
export class PeakTimePipe implements PipeTransform {

  transform(value: any, argTime?: any): any {
    const format = 'HH:mm'
    let peakCost = null;
    console.log('argTime ', argTime)
    const time = argTime ? moment(argTime, format) : moment(moment().format(format), format);
    console.log('Time ', moment(moment(argTime).format(format), format));
    const beforeTime = moment('22:00', format);
    const afterTime = moment('06:00', format);
    if (time.isSameOrBefore(beforeTime) && time.isSameOrAfter(afterTime)) {
      peakCost = value;
    } else {
      peakCost = Number(value) + 20;
    }
    return peakCost;
  }
  transformPeakStatus(pickTime: any): any {
    const format = 'HH:mm'
    const time = moment(pickTime, format);
    const beforeTime = moment('22:00', format);
    const afterTime = moment('06:00', format);
    if (time.isSameOrBefore(beforeTime) && time.isSameOrAfter(afterTime)) {
      return false;
    }
    return true;
  }
}
